import getAgentsAvailabilityConfiguration, { AgentsAvailabilityStatuses } from '@root/agents/src/api/root-agent/agents-availability-configuration';
import getNextTenBusinessDays from '@root/agents/src/utils/get-next-ten-business-days';
import useNetworkRequest from '@root/core/src/hooks/use-network-request';
import { useCallback, useState } from '@root/vendor/react';

const config = getAgentsAvailabilityConfiguration();

export default function useAgentSchedule() {
  const [operatingHours, setOperatingHours] = useState();
  const [isDuringBusinessHours, setIsDuringBusinessHours] = useState();
  const [holidays, setHolidays] = useState();
  const [nextTenBusinessDays, setNextTenBusinessDays] = useState();

  const isLoading = useNetworkRequest(config, useCallback((result) => {
    setOperatingHours(result.data.operatingHours);
    setIsDuringBusinessHours(result.data.agentsAvailability === AgentsAvailabilityStatuses.IN_OFFICE);
    setHolidays(result.data.holidays);
    setNextTenBusinessDays(getNextTenBusinessDays(result.data.operatingHours, result.data.holidays));
  }, []));

  return {
    isLoading,
    isDuringBusinessHours,
    operatingHours,
    holidays,
    nextTenBusinessDays,
  };
}
